import React from "react";
import { styles } from "../../styles";
import { WalletAmountInput } from "./WalletAmountInput";

export interface WalletBatchRow {
  recipient: string;
  amount: string;
}

export function WalletBatchRecipients({
  rows,
  onChange,
  maxForRow,
  placeholder,
  disabled,
}: {
  rows: WalletBatchRow[];
  onChange: (rows: WalletBatchRow[]) => void;
  maxForRow: (index: number) => string | null;
  placeholder: string;
  disabled?: boolean;
}) {
  return (
    <div className="wallet-batch-recipients">
      {rows.map((row, index) => {
        const max = maxForRow(index);
        const change = (patch: Partial<WalletBatchRow>) =>
          onChange(
            rows.map((current, i) =>
              i === index ? { ...current, ...patch } : current,
            ),
          );
        return (
          <div className="wallet-batch-row" key={index}>
            <input
              aria-label={`Recipient ${index + 1}`}
              style={{
                ...styles.input,
                marginBottom: 0,
                minWidth: 0,
                minHeight: 50,
              }}
              value={row.recipient}
              onChange={(event) => change({ recipient: event.target.value })}
              placeholder={placeholder}
              disabled={disabled}
            />
            <WalletAmountInput
              aria-label={`Amount for recipient ${index + 1}`}
              value={row.amount}
              onChange={(event) => change({ amount: event.target.value })}
              placeholder="Amount"
              onMax={() => max !== null && change({ amount: max })}
              maxDisabled={max === null}
              disabled={disabled}
            />
            <button
              type="button"
              className="wallet-secondary"
              aria-label={`Remove recipient ${index + 1}`}
              disabled={disabled || rows.length <= 1}
              onClick={() => onChange(rows.filter((_, i) => i !== index))}
            >
              −
            </button>
          </div>
        );
      })}
      <button
        type="button"
        className="wallet-secondary"
        disabled={disabled || rows.length >= 32}
        onClick={() => onChange([...rows, { recipient: "", amount: "" }])}
      >
        + Add recipient
      </button>
    </div>
  );
}
